import { PartSkuTypes } from "./actionTypes";



// For Grid

export const getPartSkuList = (lazyState: any) => {
  return {
    type: PartSkuTypes.GET_PART_SKU_LIST,
    lazyState,
  };
};



export const getPartSkuListSuccess = (administrators: any) => {
  return {
    type: PartSkuTypes.GET_PART_SKU_SUCCESS,
    payload: administrators,
  };
};

export const getPartSkuListError = (error: any) => {
  return {
    type: PartSkuTypes.GET_PART_SKU_FAIL,
    payload: error,
  };
};


export const resetPartskumessage=()=>{
  return {
    type: PartSkuTypes.RESET_PART_SKU_MESSAGE,
  }
}

export const getPartAutoCompleteList = (payload: any) => {
  return {
    type: PartSkuTypes.GET_PART_AUTOCOMPLETE,
    params:payload,
  };
};



export const getPartAutoCompleteSuccess = (payload: any) => {
  
  
  return {
    type: PartSkuTypes.GET_PART_AUTOCOMPLETE_SUCCESS,
    payload: payload,
  };
};

export const getPartAutoCompleteError = (error: any) => {
  return {
    type: PartSkuTypes.GET_PART_AUTOCOMPLETE_FAIL,
    payload: error,
  };
};

export const getPartSkuAutoComplete = (payload: any) => {
  return {
    type: PartSkuTypes.GET_PART_SKU_AUTOCOMPLETE,
    params:payload,
  };
};



export const getPartSkuAutoCompleteSuccess = (payload: any) => {
  
  
  return {
    type: PartSkuTypes.GET_PART_SKU_AUTOCOMPLETE_SUCCESS,
    payload: payload,
  };
};

export const getPartSkuAutoCompleteError = (error: any) => {
  return {
    type: PartSkuTypes.GET_PART_SKU_AUTOCOMPLETE_FAIL,
    payload: error,
  };
};

export const getLocationList = () => {
  return {
    type: PartSkuTypes.GET_LOCATION_LIST,
  };
};



export const getLocationListSuccess = (location: any) => {
  return {
    type: PartSkuTypes.GET_LOCATION_SUCCESS,
    payload: location,
  };
};

export const getLocationListError = (error: any) => {
  return {
    type: PartSkuTypes.GET_LOCATION_FAIL,
    payload: error,
  };
};

export const getJobsheetId = (number:any) => {
  return {
    type: PartSkuTypes.GET_JOBSHEET_ID,
    number:number
  };
};



export const getJobsheetIdSuccess = (resp: any) => {
  return {
    type: PartSkuTypes.GET_JOBSHEET_ID_SUCCESS,
    payload: resp,
  };
};

export const getJobsheetIdError = (error: any) => {
  return {
    type: PartSkuTypes.GET_JOBSHEET_ID_FAIL,
    payload: error,
  };
};

export const getConformationSku = () => {
  return {
    type: PartSkuTypes.GET_CONFORMATION_SKU,
  };
};



export const getConformationSkuSuccess = (resp: any) => {
  return {
    type: PartSkuTypes.GET_CONFORMATION_SKU_SUCCESS,
    payload: resp,
  };
};

export const getConformationSkuError = (error: any) => {
  return {
    type: PartSkuTypes.GET_CONFORMATION_SKU_FAIL,
    payload: error,
  };
};

export const getConsumptionSku = () => {
  return {
    type: PartSkuTypes.GET_CONSUMPTION_SKU,
  };
};

export const getConsumptionSkuSuccess = (resp: any) => {
  return {
    type: PartSkuTypes.GET_CONSUMPTION_SKU_SUCCESS,
    payload: resp,
  };
};

export const getConsumptionSkuError = (error: any) => {
  return {
    type: PartSkuTypes.GET_CONSUMPTION_SKU_FAIL,
    payload: error,
  };
};